module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./QualificationActivityListView.js"));
	}, "QualificationActivityListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=QualificationActivityListView!./src/pages/Shop/Product/QualificationActivityList/QualificationActivityListView.js
// module id = 850
// module chunks = 438